<template>
  <div>
    <v-container class="mb-4" fluid>
      <template v-for="produto in resposta.produtos">
        <px-cotacao-conjunta-resposta-produto-item
          ref="produtoItem"
          :produto="produto"
          :key="produto.id"/>
      </template>
    </v-container>
    <v-btn color="primary" @click="clickNext">
      Continuar
    </v-btn>
  </div>
</template>

<script>
import { SituacoesCotacao } from 'px-business-components';
import validationMixin from '@/mixins/validation-mixin';
import { orderBy } from 'lodash';
import CotacaoConjuntaRespostaProdutoItem from './CotacaoConjuntaRespostaProdutoItem.vue';

export default {
  mixins: [validationMixin],
  props: {
    resposta: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      required: false,
    },
    solicitacao: Object,
  },
  computed: {
    isInvalid() {
      const forms = this.refs_children.map((c) => c.isInvalid());
      const filesUploading = this.refs_children.map((c) => c.hasFileLoading);
      if (filesUploading.find((f) => f)) {
        this.$toast('Aguarde a finalização do envio do(s) arquivo(s)', { color: 'error' });
        return true;
      }
      return forms.find((form) => form);
    },
  },
  methods: {
    clickNext() {
      if (this.isInvalid) {
        return;
      }
      this.$emit('next');
    },
    comparePrazos(a, b) {
      if (!a.prazoPagamento) {
        return -1;
      }
      if (a.formaPagamento < b.formaPagamento) {
        return 1;
      }
      return 0;
    },
    createPrazos(cotacaoConjunta) {
      return cotacaoConjunta.prazosPagamentos
        .sort(this.comparePrazos)
        .map((prazo) => ({
          formaPagamento: prazo.formaPagamento,
          prazoPagamento: prazo.prazoPagamento,
          situacao: 'RESPONDIDA',
          precoUnitario: null,
        }));
    },
    setupProdutosEditing() {
      this.resposta.produtos = this.resposta.produtos.map((p) => ({
        ...p,
        prazos: orderBy(p.prazos, 'id'),
      }));
    },
    setupProdutos() {
      if (this.editing) {
        this.setupProdutosEditing();
        return;
      }
      this.resposta.produtos = this.solicitacao.cotacaoConjunta.produtos
        .filter((produto) => SituacoesCotacao.ABERTAS.includes(produto.situacao))
        .map((produto) => ({
          cotacaoConjuntaProduto: produto,
          situacao: 'RESPONDIDA',
          prazos: this.createPrazos(this.solicitacao.cotacaoConjunta),
          especificacaoProduto: null,
          impostos: {
            tipoAplicacaoIcms: null,
            tipoAplicacaoIpi: null,
            icms: null,
            ipi: null,
          },
          arquivos: [],
        }));
    },
  },
  created() {
    this.setupProdutos();
  },
  mounted() {
    this.refs_children = this.$refs.produtoItem;
  },
  components: {
    pxCotacaoConjuntaRespostaProdutoItem: CotacaoConjuntaRespostaProdutoItem,
  },
};
</script>
